import controller from './header.controller';

export default {
  controller,
  template: require('./header.html')
};



// WEBPACK FOOTER //
// src/app/no-auth/components/header/header.component.ts